var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DeleteConfirmationNumberModal',{attrs:{"action":_vm.action,"customBodyText":_vm.bodyText,"customConfirmationText":_vm.confirmationText,"customHeaderText":_vm.headerText,"itemType":_vm.itemType}})
}
var staticRenderFns = []

export { render, staticRenderFns }